import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import * as Sentry from "@sentry/angular";

@Injectable()
export class SentryCustomErrorHandler extends Sentry.SentryErrorHandler {
  constructor(private snackBar: MatSnackBar) {
    /**
     * Pass options to Sentry's ErrorHandler here. For Example:
     * ```super({ logErrors: false });```
     */
    super({ showDialog: false });
  }

  handleError(error: any): void {
    // Your custom error handling logic
    this.snackBar.open("Something wrong happened. We got it.", 'OK', { duration: 2000 })

    // Call Sentry's error handler to capture errors:
    super.handleError(error);
  }
}
